import React, { useState } from 'react';
import { ADMIN_REVIEW_LOG_PREVIEW } from '../../config/constants';
import {
  buildAdminReviewEntries,
  adminReviewActionLabel,
  formatAdminReviewerLabel,
  formatAdminReviewTimestamp,
  adminReviewEntryDetail,
} from '../../utils/submissions';

const AdminReviewLogPanel = ({ sub, hint, collapsible = false }) => {
  const [expanded, setExpanded] = useState(false);
  const entries = buildAdminReviewEntries(sub);
  const scrollHistory = entries.length > ADMIN_REVIEW_LOG_PREVIEW;

  const header = (
    <div className={`admin-review-log__header${collapsible ? " admin-review-log__header--toggle" : ""}`}>
      {collapsible ? (
        <button
          type="button"
          className="admin-review-log__toggle"
          onClick={() => setExpanded((open) => !open)}
          aria-expanded={expanded}
        >
          <span className="admin-review-log__title">
            <i className="fas fa-clipboard-check" aria-hidden="true"></i>
            Admin review history
            {entries.length > 0 ? (
              <span className="admin-review-log__badge">{entries.length}</span>
            ) : null}
          </span>
          <i
            className={`fas fa-chevron-${expanded ? "up" : "down"} admin-review-log__chevron`}
            aria-hidden="true"
          ></i>
        </button>
      ) : (
        <h4 className="admin-review-log__title">
          <i className="fas fa-clipboard-check" aria-hidden="true"></i>
          Admin review history
        </h4>
      )}
    </div>
  );

  const body = (
    <>
      {hint ? <p className="admin-review-log__hint">{hint}</p> : null}
      {!entries.length ? (
        <p className="admin-review-log__empty">
          No admin actions logged yet. Approve share structure or move pipeline steps to record history (after backend deploy).
        </p>
      ) : (
        <>
          {scrollHistory ? (
            <p className="admin-review-log__count">
              {entries.length} entries — scroll for older actions
            </p>
          ) : null}
          <ul className={`admin-review-log__list${scrollHistory ? " admin-review-log__list--scroll" : ""}`}>
            {entries.map((entry, i) => (
              <li key={`${entry.action}-${entry.at}-${i}`} className="admin-review-log__item">
                <div className="admin-review-log__item-title">
                  {adminReviewActionLabel(entry.action)}
                </div>
                <div className="admin-review-log__item-meta">
                  {formatAdminReviewerLabel(entry)}
                  <span> · </span>
                  {formatAdminReviewTimestamp(entry.at)}
                </div>
                {adminReviewEntryDetail(entry) ? (
                  <div className="admin-review-log__item-detail">
                    {adminReviewEntryDetail(entry)}
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );

  if (collapsible) {
    return (
      <div className="admin-review-log admin-review-log--collapsible">
        {header}
        {expanded ? <div className="admin-review-log__body">{body}</div> : null}
      </div>
    );
  }

  return (
    <div className="admin-review-log">
      {header}
      <div className="admin-review-log__body">{body}</div>
    </div>
  );
};

export default AdminReviewLogPanel;
